import WebFont from 'webfontloader';
import { fabric } from 'fabric';

(globalThis as any).WebFont = WebFont;
(globalThis as any).fabric = fabric;

// Some legacy files refer to `window` globals even in non-browser contexts.
if (typeof window !== 'undefined') {
  (window as any).WebFont = WebFont;
  (window as any).fabric = fabric;
}
